import { initState } from './../App/App.config';

export default (state, action) => {
  switch (action.type) {
    case 'ENTER_CONTRACT_NUMBER':
      return {
        ...state,
        contractNumber: action.payload,
        showForm: {
          ...state.showForm,
          showEnteredCM: true,
        },
      };
    case 'MAKE_CM_CALL':
      return {
        ...state,
        currentCMDetails: {
          ...state.currentCMDetails,
          loading: action.payload.loading,
        },
      };
    case 'IS_BIC_ASSET':
      return {
        ...state,
        hasError: {
          ...state.hasError,
          isBicAsset: action.payload,
        },
      };
    case 'SET_ENTERED_CM':
      return {
        ...state,
        currentCMDetails: {
          ...state.currentCMDetails,
          contractNumber: action.payload.cmData,
        },
      };
    case 'SET_ENTERED_AUTH_EMAIL':
      return {
        ...state,
        currentCMDetails: {
          ...state.currentCMDetails,
          authEmail: action.payload.userEnteredAuthEmail,
        },
        hasError: {
          ...state.hasError,
          authEmail: action.payload.hasAuthError,
          invalidEmail: action.payload.hasValidationError,
        },
      };
    case 'USER_IS_TYPING_AUTHEMAIL':
      return {
        ...state,
        currentCMDetails: {
          ...state.currentCMDetails,
          authEmail: action.payload.currentCMAuthEmail,
        },
        hasError: {
          ...state.hasError,
          isBicAsset: action.payload.isBicAssetBanner,
          authEmail: action.payload.currentCMAuthEmailFieldError,
          contractNumberError: false
        },
        showForm: {
          ...state.showForm,
          // disbale next field to enter authEmail.
          showEnteredCM: false,
        },
      };
    case 'AUTH_EMAIL_INVALID_FORMAT':
      return {
        ...state,
        currentCMDetails: {
          ...state.currentCMDetails,
          authEmail: action.payload.userEnteredAuthEmail,
        },
        hasError: {
          ...state.hasError,
          invalidEmail: action.payload.hasError,
          authEmail: action.payload.hasAuthError,
        },
      };
    case 'CM_RESPONSE_RECEIVED':
      return {
        ...state,
        currentCMDetails: {
          ...state.currentCMDetails,
          loading: false, // loading to be false.
          encryptedCMAuthEmail: action.payload.encryptedCMAuthEmail,
          showCheckmark: true,
        },
        showForm: {
          ...state.showForm,
          showEnteredCM: true, // show next field to enter authEmail.
        },
      };
    case 'DISABLE_CHECKMARK':
      return {
        ...state,
        currentCMDetails: {
          ...state.currentCMDetails,
          showCheckmark: false,
        }
      };
    case 'ENTER_CASE_DESCRIPTION':
      return {
        ...state,
        caseDescription: action.payload,
      };
    case 'SHOW_ENTRED_CONTRACT_NUMBER':
      return {
        ...state,
        showForm: {
          ...state.showForm,
          showEnteredCM: true,
        },
      };
    case 'VALIDATE_AUTH_EMAIL':
      return {
        ...state,
        currentCMDetails: {
          ...state.currentCMDetails,
          authEmail: action.payload.userEnteredAuthEmail,
        },
        hasError: {
          ...state.hasError,
          authEmail: action.payload.authEmailError,
          invalidEmail: !action.payload.isEmailValid,
        },
      };
    case 'MAKE_AUTH_EMAIL':
      return {
        ...state,
        currentCMDetails: {
          ...state.currentCMDetails,
          authEmail: action.payload,
        },
      };
    case 'VALIDATE_NEW_CM_FIRST_NAME':
      return {
        ...state,
        hasError: {
          ...state.hasError,
          fName: action.payload,
      },
    };
    case 'VALIDATE_NEW_CM_LAST_NAME':
      return {
        ...state,
        hasError: {
          ...state.hasError,
          lName: action.payload,
      },
    };
    case 'VALIDATE_NEW_CM_AUTH_EMAIL':
      return {
        ...state,
        hasError: {
          ...state.hasError,
          newCMEmail: action.payload,
      },
    };
    case 'SHOW_CM_FIELD_VALIDATION':
      return {
        ...state,
        hasError: {
          ...state.hasError,
          currentCM: action.payload,
        },
        currentCMDetails: {
          ...state.currentCMDetails,
          loading: false, // stop loading.
        },
        showForm: {
          ...state.showForm,
          showEnteredCM: false, // Do not show next field.
        },
      };
    case 'NEW_CM_FIRST_NAME':
      return {
        ...state,
        newCmDetails: {
          ...state.newCmDetails,
          firstName: action.payload.firstName,
        },
        hasError: {
          ...state.hasError,
          fName: action.payload.hasError,
        },
      };
    case 'NEW_CM_LAST_NAME':
      return {
        ...state,
        newCmDetails: {
          ...state.newCmDetails,
          lastName: action.payload.lastName,
        },
        hasError: {
          ...state.hasError,
          lName: action.payload.hasError,
        },
      };
    case 'NEW_CM_AUTH_EMAIL':
      return {
        ...state,
        newCmDetails: {
          ...state.newCmDetails,
          email: action.payload.email,
        },
        hasError: {
          ...state.hasError,
          newCMEmail: action.payload.hasError,
        },
      };
    case 'NEW_CM_PHONE':
      return {
        ...state,
        newCmDetails: {
          ...state.newCmDetails,
          phone: action.payload,
        },
      };
    case 'MAKE_CM_AUTHORIZED':
      return {
        ...state,
        authorized: action.payload,
      };
    case 'ADD_SIGNATURE':
      return {
        ...state,
        userSessionSign: {
          ...state.userSessionSign,
          sign: {
            ...state.userSessionSign.sign,
            ...action.payload,
          }
        },
      };
    case 'CONTRACT_NUMBER_ERROR': 
      return {
        ...state,
        hasError: {
          ...state.hasError,
          contractNumberError: true           
        },
        currentCMDetails: {
          ...state.currentCMDetails,
          loading: false, // stop loading.
        },
        showForm: {
          ...state.showForm,
          showEnteredCM: false, // Do not show next field.
        },
      }  
    case 'DISABLE_SHOWN_ERROR':
      return {
        ...state,
        hasError: {
          ...state.hasError,
          [action.payload.type]: action.payload.hasError,
          invalidEmail: false,
          authEmail: false
        },
        showForm: {
          ...state.showForm,
          showEnteredCM: false, // Do not show next field.
        },
      };
    case 'UPDATE_CM_ERROR':
      return {
        ...state,
        error: action.payload,
      };
    case 'TAKING_MORE_THAN_REQUIRED':
      return {
        ...state,
        loadingMoreThanRequired: true,
      };
    case 'EXPAND_FOOTER_ON_ERROR': 
      return {
        ...state,
        expandFooterOnError: true
      }
    case 'HANDLE_SUBMIT_AGAIN':
      return {
        ...state,
        submitAgain: {
          ...state.submitAgain,
          [action.payload.type]: action.payload.value
        }
      };  
    case 'RESET_STATE': 
      return {
        ...state,
        ...initState
      }  
    default:
      return state;
    }
};